import { useConfigRestrict } from "@/hooks/useConfigRestrict";
import { userStore } from "@/stores/userStore";
import { CarouselAttrs, CarouselItem } from "@locent/types";

import { BaseComponent } from "../base/baseComponent";
import { CompType } from "../base/baseEnum";

/** 轮播图数据项接口 */

/** 轮播图组件类 */
export class CarouselComponent extends BaseComponent<
  CarouselAttrs & {
    [key: string]: string | number | boolean | object | null | undefined;
  }
> {
  constructor(
    data: Partial<
      BaseComponent<
        CarouselAttrs & {
          [key: string]: string | number | boolean | object | null | undefined;
        }
      >
    > = {},
  ) {
    super(data);
    this.type = CompType.carousel;
  }

  /** 获取轮播图数据列表 */
  public getCarouselItems(): CarouselItem[] {
    const { getStatusByDeny } = useConfigRestrict();
    return (
      this.lang_attrs?.list?.filter((item) => {
        if (item.status !== 1) return false;

        // 渠道规则
        // if (getStatusByDeny(item.deny_pack, item.deny_pack_type, true)) {
        //   return true;
        // }
        if (getStatusByDeny(item.deny_pack, item.deny_pack_type, true)) {
          // Check recharge_type
          // recharge_type=1: 不限制, 2: 仅限充值用户,3: 仅限未充值用户
          if (item.recharge_type === 1) {
            return true;
          }
          if (item.recharge_type === 2 && userStore.userInfo?.is_pay === 1) {
            return true;
          }
          if (item.recharge_type === 3 && userStore.userInfo?.is_pay === 0) {
            return true;
          }

          return false;
        } else {
          return false;
        }
      }) || []
    );
  }

  /** 设置轮播图数据列表 */
  public setCarouselItems(items: CarouselItem[]): void {
    this.setAttrs({ data_list: items });
  }

  public getStyle(): number {
    return (this.style as number) || 1;
  }
}
